import { PostObserver } from "@/components/app/post/post-observer";
import DesoAvatar from "@/components/shared/deso-avatar";
import { UserDisplayNameWithStatus } from "@/components/shared/user-display-name-with-status";
import { usePostContext } from "@/contexts/post-context";
import { cn } from "@/utils/lib";
import { getUserName } from "@/utils/usernames";

import { PostDetailsView } from "../../post/post-details-header";
import { PostHeaderBody } from "../../post/post-header-body";
import { PostStatusRow } from "../../post/post-status-row";

type NotificationPostDetailsProps = {
  className?: string;
  showRepost?: boolean;
  hideNotificationHeader?: boolean;
};

export const NotificationPostDetails = ({
  showRepost = true,
  className = "",
  hideNotificationHeader = false,
}: NotificationPostDetailsProps) => {
  const { repost, isPureRepost, isPostRemoved, post, poster, hideHeader } =
    usePostContext();

  const creatorPublicKey = (isPureRepost ? repost : post)?.poster?.publicKey;
  const postHash = (isPureRepost ? repost : post)?.postHash;

  // If a post is hidden, then don't return anything.
  if (isPostRemoved || !post.postHash || !creatorPublicKey || !postHash) {
    return null;
  }

  return (
    <div className={className}>
      {isPureRepost && (
        <div className="mb-6 ml-2 pt-0">
          <PostStatusRow section="feed" className="-mt-4" />
        </div>
      )}

      {(!hideNotificationHeader || !hideHeader) && (
        <div className="flex items-center gap-2">
          {poster && <DesoAvatar {...{ account: poster, size: 40 }} />}
          <div className="flex flex-col gap-1">
            {poster && (
              <UserDisplayNameWithStatus
                account={poster}
                clickable={false}
                mobileAccountCard={false}
                whaleSize={16}
                className="
                  font-sans text-sm font-semibold text-foreground
                  hover:no-underline
                "
              />
            )}
            <span className="text-xs text-muted">
              {poster && getUserName({ account: poster })}
            </span>
          </div>
        </div>
      )}
      <div
        className={cn("w-full grow", {
          "pt-2 pl-12": !hideNotificationHeader && !isPureRepost,
          "mb-2 pt-4": repost && showRepost,
        })}
      >
        <PostObserver>
          <PostHeaderBody
            {...{
              showRepost,
              hideQuoteUpvote: true,
              postType: PostDetailsView.feed,
              PostBodyClass: cn("mb-2", {
                "mb-0": !hideNotificationHeader,
              }),
            }}
          />
        </PostObserver>
      </div>
    </div>
  );
};
